import React from "react";

import UrlIcon from "../icons/call.svg";

const ProductOverview = ({actionProvider}) => {
  const options = [
    { text: "Machine Learning with Python 🤖", handler: actionProvider.handleFeatures, id: 1 },
    { text: "Cyber Security Fundamentals 🔐", handler: actionProvider.handleFeatures, id: 2 },
  ];

  return (
    <div className="options">
      {/* <p>Qshikshak simplifies school operations by bringing everything—attendance, exams, fees, communication, and more—into one secure platform.</p> */}
      <div className="options-containerF">
          {options.map((option) => {
            return (
              <div
                className="option-itemF"
                onClick={option.handler}
                key={option.id}
              >
                {option.text}
              </div>
            );
          })}
        </div>
    </div>
  );

};

export default ProductOverview;
